export default "__VITE_ASSET__BsX1_LH5__"